import React, { useState } from 'react'
import { InputField, TextAreaInput } from '../../Input';

export default function ChatInput({ user, socket, chat }) {

    const [newMessage, setNewMessage] = useState('');
    
    const sendMessage = () => {
        socket.emit('sendMessage',{
            sender: user._id,
            chat: chat._id,
            message: newMessage,
            isAnnouncement: false,
        })
        setNewMessage('')
    }

    return (
        <form onSubmit={(e) => {
            e.preventDefault();
            sendMessage();
        }}>
            <div className="h-16 align-bottom flex px-4 justify-center items-center gap-3 absolute bottom-16 w-full left-0 pr-3 pt-1 bg-white">
                <div className="w-4/5">
                    <textarea
                        placeholder="Enter Message..."
                        rows={1}
                        name='message' id="msg-Input"
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        className={`w-full py-3 mt-1 text-xs border-2 border-gray-300 rounded-lg focus:outline-blue-800 px-4`}
                    ></textarea>
                </div>
                <button type="submit" className="flex w-1/5 py-3 text-xs gap-1 font-semibold rounded-xl justify-center items-center mb-2 text-white bg-blue-800 border border-blue-800">
                    <span>
                        Send
                    </span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                            <path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
                        </svg>
                    </span>
                </button>
            </div>
        </form>
    );
}
